<template>
  <div class="map-div">
    <div ref="map-room" id="map-room">
      <!-- <div :title="fullscreen ? '退出全屏' : '全屏'">
        <svg-icon
          v-show="!fullscreen"
          @click="enterFullscreen"
          class="icon-full"
          icon-class="full"
        />
        <svg-icon
          v-show="fullscreen"
          @click="exitFullscreen"
          class="icon-full"
          icon-class="fullout"
        />
      </div> -->
      <!-- <mesTabs /> -->

      <mainItem :mainObj="mainObj" ref="mainItem" />
    </div>
  </div>
</template>

<script>
import BDMap from "../../utils/cesiumBD/map/BDMap";
import {
  createOSMMapLayer,
  createTDT_SL_MapLayer,
  createTDT_YX_MapLayer,
  createTDT_ZJ_MapLayer,
  createARCGISMapLayer,
  createGD_SL_MapLayer,
  createGD_YX_MapLayer,
  createBingMapLayer,
  createBDMapLayer,
  createGridMapLayer,
  createCoordMapLayer,
  createSingleTileMapLayer,
  createFeaturesLayer,
  createTilesetLayer,
  createHaiTuMapLayer,
  createChinaMapLayer,
  createXinTuDiQiu_ZJ_MapLayer,
  createGuGe_YX_MapLayer,
  createARCGIS_ZJ_LSMapLayer,
} from "../../utils/cesiumBD/map/Layerfactory";
import { computeSurfacePoints } from "../../utils/cesiumBD/analysis/utils/index";
import TilesetLayer from "@/utils/cesiumBD/layer/TilesetLayer.js";
import GeoJsonLayer from "@/utils/cesiumBD/layer/GeoJsonLayer";
import { getZhjDeviceLocation, getlistDeviceLocation } from "@/api/device/index.js";
import DomUtil from "../../utils/cesiumBD/utils/DomUtil";

/*******************UI*********************/
import com_point from "@/components/VectorPlot/compoent/point.vue";
import com_billboard from "@/components/VectorPlot/compoent/billboard.vue";
import com_line from "@/components/VectorPlot/compoent/line.vue";
import com_polygon from "@/components/VectorPlot/compoent/polygon.vue";
import com_polygon3 from "@/components/VectorPlot/compoent/polygon3.vue";
import com_circle from "@/components/VectorPlot/compoent/circle.vue";
import com_rectangle from "@/components/VectorPlot/compoent/rectangle.vue";
import com_ellipsoid from "@/components/VectorPlot/compoent/ellipsoid.vue";
import com_cylinder from "@/components/VectorPlot/compoent/cylinder.vue";
import com_wall from "@/components/VectorPlot/compoent/wall.vue";
import com_polylineVolume from "@/components/VectorPlot/compoent/polylineVolume.vue";
import com_svgEdit from "@/components/MilitaryPlot/svgEdit.vue";
import { getCommonAjax } from "@/api/common";
import { getAdsbLocationGJ } from "@/api/ADSB";
import PathAnimation from "@/utils/cesiumBD/animation/PathAnimation";
import mesTabs from "@/components/mesTabs/index.vue";
import DeviceMsg from "../DeviceMsg/super.vue";
import ADSMsg from "../DeviceMsg/ads.vue";
import PopLayer from "@/utils/cesiumBD/animation/PopLayer";
import BeidouGrid from "@/utils/cesiumBD/beidouGrid/index";
import axios from "axios";
let popCollection = [];
import { BDWebSocket } from "./BDWebSocket.js";
import { getPositionTranslation } from "./LocalWorldTransform";
import { listDeviceLocationTodayOffline } from "@/api/DK.js";
import { getModelUrl } from "./getModel";
import * as turf from "@turf/turf";
import flightDetails from "./flightDetails.vue";
import mainItem from "./mainItem.vue";
import WeatherSDK from "@/utils/cesiumBD/WeatherSDK/WeatherSDK.js";

// 全局变量：ADS-B 数据源（对应 datingDataSource）
let adsbDataSource = null;
// ADS-B 位置采样队列：为每个ICAO维护样本，用于 SampledPositionProperty 插值
const adsbSampleStore = new Map(); // icao -> { property, times: [JulianDate, ...] }
// 上一帧位置存储，用于自算运动航向
const prevPositionStore = new Map(); // icao -> { position: Cartesian3, heading: number(弧度) }
// 图片机头朝向偏移量（0 = 机头朝上, π/2 = 机头朝右, 以此类推）
const IMAGE_HEADING_OFFSET = 0;
// 位置采样时间偏移（秒）：将目标点时间戳推迟，使飞机始终处于插值运动状态
const POSITION_TIME_OFFSET = 3;

// Catmull-Rom 样条插值工具（均匀参数化，C1 连续，无振荡）
const CatmullRom = {
  /**
   * @param {Cesium.Cartesian3} p0 前一个控制点
   * @param {Cesium.Cartesian3} p1 段起点
   * @param {Cesium.Cartesian3} p2 段终点
   * @param {Cesium.Cartesian3} p3 后一个控制点
   * @param {number} t [0,1] 插值比例
   * @returns {Cesium.Cartesian3}
   */
  interpolate(p0, p1, p2, p3, t) {
    const t2 = t * t;
    const t3 = t2 * t;
    // Catmull-Rom 基矩阵系数
    const c0 = 0.5 * (-t + 2 * t2 - t3);
    const c1 = 0.5 * (2 - 5 * t2 + 3 * t3);
    const c2 = 0.5 * (t + 4 * t2 - 3 * t3);
    const c3 = 0.5 * (-t2 + t3);
    return new Cesium.Cartesian3(
      c0 * p0.x + c1 * p1.x + c2 * p2.x + c3 * p3.x,
      c0 * p0.y + c1 * p1.y + c2 * p2.y + c3 * p3.y,
      c0 * p0.z + c1 * p1.z + c2 * p2.z + c3 * p3.z
    );
  },
};
// 全局 PinBuilder 实例（复用，避免重复创建）
const pinBuilder = new Cesium.PinBuilder();
// 飞机聚合弹窗集合（对应 popCollection）
let adsbPopCollection = [];
// 株洲圆实体引用
let zhuzhouCircleEntity = null;
// 雄安圆实体引用
let xionganCircleEntity = null;

let WeatherSDKInstance = null; // 天气SDK实例

export default {
  components: {
    mesTabs,
    mainItem,
  },
  data() {
    return {
      fullscreen: false,
      mainObj: {},
    };
  },
  mounted() {
    // this.websocket = new BDWebSocket();
    // this.websocket.init();
    // 1.禁用右键菜单
    document.oncontextmenu = new Function("event.returnValue=false");
    this.initMap();
    // DomUtil.fullscreenchange(this.fullscreenchange);
    // this.addModel();

    WeatherSDKInstance = new WeatherSDK(viewer, {
      apiKey: "62bd76ae5c7ad8928599de420985d6d5", // 替换为你的天气SDK API Key
    });

    let bd;
    this.$bus.$on("grid-change", (value) => {
      if (value) {
        bd = new BeidouGrid({});
        return;
      }
      if (bd) {
        bd.clear();
        bd = null;
      }
    });

    this.$bus.$on("line-list-change", (value, arrLine) => {
      if (value == "totalClick") {
        this.queryDataAll();
        return;
      }
      if (value == "onLineClick") {
        this.$dialog.open({
          id: `今日飞行数`,
          title: `今日飞行数`,
          theme: "feature-dialog",
          shade: false,
          area: {
            height: "760px",
            width: "940px",
          },
          location: {
            top: "100px",
          },
          content: {
            type: "vue",
            subCom: flightDetails,
            subData: arrLine,
          },
        });

        // this.mainObj.subTitle="今日飞行数";
        // this.mainObj.subData=arrLine;

        // this.$refs["mainItem"].open();
        return;
      }
      if (value == "offLineClick") {
        // this.queryDataOff();
        // return;

        this.$dialog.open({
          id: `今日在线数`,
          title: `今日在线数`,
          theme: "feature-dialog",
          shade: false,
          area: {
            height: "760px",
            width: "940px",
          },
          location: {
            top: "100px",
          },
          content: {
            type: "vue",
            subCom: flightDetails,
            subData: arrLine,
          },
        });
        return;
      }
      if (value == "flightSelected") {
        this.clearData();
        this.queryData(arrLine);
      }
    });

    this.$bus.$on("traceDataFetched", (traceData, info) => {
      this.doADSBFlyServer(traceData, info);
    });

    this.$bus.$on("traceDataFetchedclearData", () => {
      this.clearData();
    });

    this.$bus.$on("initADSPointAll", (res, clear) => {
      if (clear) {
        this.clearData();
        this.drawZhuzhouCircle();
      }
      this.initADSPoint(res);
    });

    this.$bus.$on("clearADSPointAll", (res) => {
      this.clearData();
      this.clearADSPoints();
      WeatherSDKInstance.removeAllWeatherLayers();
    });

    this.$bus.$on("drawZhuzhouCircle", () => {
      this.drawZhuzhouCircle();
    });

    this.$bus.$on("removeZhuzhouCircle", () => {
      this.removeZhuzhouCircle();
    });
    this.$bus.$on("adsbWeatherTypeChange", (info) => {
      if (!info.type) {
        WeatherSDKInstance.removeAllWeatherLayers();
        return;
      }
      WeatherSDKInstance.removeAllWeatherLayers();
      WeatherSDKInstance.loadWeatherLayer(info.type);
    });
  },
  beforeDestroy() {
    this.$bus.$off("adsbWeatherTypeChange");
    this.$bus.$off("line-list-change");
    this.$bus.$off("grid-change");
    this.$bus.$off("traceDataFetched");
    this.$bus.$off("traceDataFetchedclearData");
    this.$bus.$off("clearADSPointAll");
    this.$bus.$off("drawZhuzhouCircle");
    this.$bus.$off("removeZhuzhouCircle");
  },
  methods: {
    addModel() {
      let modelMatrix = Cesium.Transforms.eastNorthUpToFixedFrame(
        Cesium.Cartesian3.fromDegrees(-75.628982, 40.028194),
        new Cesium.HeadingPitchRoll()
      );

      // 定义模型的路径和其他选项
      let modelOptions = {
        uri: "data/mx/dajiang.gltf",
        scale: 1.0,
        minimumPixelSize: 128,
        maximumScale: 20000,
        modelMatrix: modelMatrix,
      };

      // 把模型加到场景里！
      viewer.scene.primitives.add(new Cesium.Model(modelOptions));
    },
    fullscreenchange() {
      if (!document.fullscreenElement) {
        this.fullscreen = false;
      }
    },
    exitFullscreen() {
      DomUtil.exitFullscreen();
      this.fullscreen = false;
    },
    enterFullscreen() {
      DomUtil.enterFullscreen(this.$refs["map-room"]);
      this.fullscreen = true;
    },
    initMap() {
      Cesium.Ion.defaultAccessToken = ionKey;
      // //武汉位于东经113°41′-115°05′、北纬29°58′-31°22′之间
      //west1.6913513042260127  south :03914621287365193 "east"22816489202716332
      //north”:0.64176229022845341

      //离线地形
      // var terrainProvider = new Cesium.CesiumTerrainProvider({
      //   url: 'http://localhost:8999/gisData/dem/hubei',
      //   requestVertexNormals: true
      // });

      //地形
      //120.88363436982,31.4334654249251,120.92016806826,31.5553034283221
      Cesium.Camera.DEFAULT_VIEW_RECTANGLE = new Cesium.Rectangle(
        Cesium.Math.toRadians(120.88363436982),
        Cesium.Math.toRadians(31.4334654249251),
        Cesium.Math.toRadians(120.92016806826),
        Cesium.Math.toRadians(31.5553034283221)
      );
      var DBmap = new BDMap("map-room", {
        sceneModePicker: false,
        //terrainProvider: Cesium.createWorldTerrain(),
        contextOptions: {
          requestWebgl1: false, // 尝试使用 WebGL 2，如果不可用则回退到 WebGL 1
        },
      });

      //深度检测
      // DBmap.viewer.scene.globe.depthTestAgainstTerrain = true; //开启深度检测
      //部件
      // DBmap.viewer.distanceLegend.enable = true;
      // DBmap.viewer.locationBar.enable = true;
      // DBmap.viewer.compass.enable = true;
      // DBmap.viewer.zoomController.enable = true;
      window.DBmap = DBmap; //注册全局

      window.DBdataSource = new Cesium.CustomDataSource("window");
      window.DBentityCollection = window.DBdataSource.entities;
      viewer.dataSources.add(window.DBdataSource);

      // 设置鼠标滚轮缩放的灵敏度
      //viewer.scene.screenSpaceCameraController.zoomFactor = 0.1; // 缩放速度因子，
      //viewer.scene.screenSpaceCameraController.inertiaZoom = 0.1; //惯性因子
      //viewer.scene.screenSpaceCameraController.minimumZoomDistance = 10;
      //
      //this.addData();
      //this.zhihuiji();

      //DBmap.plotUti.bindCallbackEdit(this.callbackEdit);

      // this.initFly2();

      // this.initPoint(); //初始化打点数据
      localStorage.setItem("QueryTime", "line1");
      this.queryDataAll();
    },
    /**
     * 以株洲为中心画一个半径为400公里的圆
     */
    drawZhuzhouCircle() {
      // 如果已经存在，先移除
      this.removeZhuzhouCircle();

      const centerLon = 113.13; // 株洲中心经度
      const centerLat = 27.83; // 株洲中心纬度
      const radiusInMeters = 400000; // 400公里转换为米

      zhuzhouCircleEntity = viewer.entities.add({
        name: "株洲400公里警戒区",
        position: Cesium.Cartesian3.fromDegrees(centerLon, centerLat),
        ellipse: {
          semiMinorAxis: radiusInMeters,
          semiMajorAxis: radiusInMeters,
          material: new Cesium.RadarWaveMaterialProperty({
            color: Cesium.Color.RED.withAlpha(0.2), // 半透明红色填充
          }),
          outline: true,
          outlineColor: Cesium.Color.RED,
          outlineWidth: 2,
          height: 0, // 贴地显示
        },
      });

      // 同时绘制雄安扫描圆
      this.drawXionganCircle();
    },
    /**
     * 移除以株洲为中心的圆
     */
    removeZhuzhouCircle() {
      if (zhuzhouCircleEntity) {
        viewer.entities.remove(zhuzhouCircleEntity);
        zhuzhouCircleEntity = null;
      }
      // 同时移除雄安扫描圆
      this.removeXionganCircle();
    },
    /**
     * 以雄安新区为中心画扫描圆
     */
    drawXionganCircle() {
      this.removeXionganCircle();

      const centerLon = 116.05; // 雄安新区中心经度
      const centerLat = 39.03; // 雄安新区中心纬度
      const radiusInMeters = 400000; // 400公里半径

      xionganCircleEntity = viewer.entities.add({
        name: "雄安新区400公里扫描区",
        position: Cesium.Cartesian3.fromDegrees(centerLon, centerLat),
        ellipse: {
          semiMinorAxis: radiusInMeters,
          semiMajorAxis: radiusInMeters,
          material: new Cesium.RadarWaveMaterialProperty({
            color: Cesium.Color.RED.withAlpha(0.2), // 半透明红色填充
          }),
          outline: true,
          outlineColor: Cesium.Color.RED,
          outlineWidth: 2,
          height: 0, // 贴地显示
        },
      });
    },
    /**
     * 移除雄安扫描圆
     */
    removeXionganCircle() {
      if (xionganCircleEntity) {
        viewer.entities.remove(xionganCircleEntity);
        xionganCircleEntity = null;
      }
    },
    queryDataAll() {
      this.clearData();
      this.setViewAll();
      this.initPoint(); //初始化打点数据
    },
    queryDataonLine() {
      this.clearData();
      //this.setViewLine();
      this.initFly2(); //初始化打点数据
    },
    queryDataOff() {
      this.clearData();
      this.setViewOff();
      let image = "data/img/marker/feiji5.png";

      const loading = this.$loading({
        lock: true,
        text: "数据同步中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let baseH = 0; //modelBaseH; //基础高度8千米
      listDeviceLocationTodayOffline()
        .then((res) => {
          loading.close();
          let result = res.result;
          console.log("总个数", result.length);
          let count_use = 0;
          for (let i = 0; i < result.length; i++) {
            let card = result[i];
            if (card.longitude > 1 && card.latitude > 1) {
              count_use++;
              var p = Cesium.Cartesian3.fromDegrees(
                card.longitude,
                card.latitude,
                card.altitude + baseH
              );

              var id = card.cardNumber + "_小飞机";
              var text = `卡号(${card.cardNumber})`;

              let entity = this.createBillboardEntityFly(p, id, text, image);
              DBentityCollection.add(entity);

              if (!entity.hasPop) {
                var pop = new PopLayer({
                  entity: entity,
                  dialog: this.$dialog,
                  componet: DeviceMsg,
                  subData: card.cardNumber,
                  title: "设备信息",
                });

                popCollection.push(pop);

                entity.hasPop = true;
              }
            }
          }

          console.log("真实数", count_use);
        })
        .catch((e) => {
          loading.close();
          console.error(e);
        });
      //this.initPoint("data/img/marker/feiji5.png"); //初始化打点数据
    },

    clearData() {
      DBentityCollection.removeAll();

      popCollection.forEach((pop) => {
        pop.close();
      });

      popCollection.length = 0;
    },
    queryData(arrLine) {
      this.initFlyServer(arrLine);
    },

    setViewAll() {
      let item = {
        view: {
          y: 41.460545,
          x: 112.292389,
          z: 10205367.4,
          heading: 6.3,
          pitch: -89.5,
          roll: 0,
        },
      };

      DBmap.setCameraView(item.view);
    },
    setViewLine() {
      let item = {
        view: {
          y: 23.051009,
          x: 110.263246,
          z: 28379.02,
          heading: 63.3,
          pitch: -16.6,
          roll: 360,
        },
      };

      DBmap.setCameraView(item.view);
    },

    setViewOff() {
      let item = {
        view: {
          y: 8.02701,
          x: 109.374152,
          z: 3540098.1,
          heading: 8.9,
          pitch: -57.5,
          roll: 358.7,
        },
      };

      DBmap.setCameraView(item.view);
    },

    /**
     * 加载ADS-B飞机数据（聚合模式）
     * @param {Object} res - OpenSky接口返回数据
     * @param {String} image - 飞机图标（默认使用指定图标）
     */
    initADSPoint(res, image) {
      // 固定飞机图标路径
      image = "data/img/marker/feijif.png";
      // 解析OpenSky返回的飞机状态数据
      let result = res.states || [];
      // 过滤有效数据（经纬度非空且大于1，高度可选）
      const validPlanes = result.filter(
        (card) => card.longitude > 1 && card.latitude > 1
      );

      console.log(`加载ADS-B飞机数据：共${validPlanes.length}架有效飞机`);

      // === 1. 初始化数据源（不使用聚合） ===
      if (!adsbDataSource) {
        adsbDataSource = new Cesium.CustomDataSource("adsb-planes");
        viewer.dataSources.add(adsbDataSource);
      }

      // === 2. 遍历飞机数据，更新或创建实体 ===
      validPlanes.forEach((card) => {
        const icao = card.icao;
        const latitude = card.latitude;
        const longitude = card.longitude;
        const altitude = card.altitude;
        const direction = card.direction;
        const speed = card.speed;
        const updateTime = card.updateTime;
        const callNumber = card.callNumber;
        const transponder = card.transponder;
        const rateClimb = card.rateClimb;
        const id = `${icao}_小飞机`;
        const position = Cesium.Cartesian3.fromDegrees(longitude, latitude, altitude);
        // 自算运动航向：用前后坐标算 bearing，不依赖接口 direction 字段
        let heading;
        const prevData = prevPositionStore.get(card.icao);
        if (!prevData || !prevData.position) {
          // 首帧：回退使用接口 direction，并转换到 Cesium 坐标系
          heading = -Cesium.Math.toRadians(direction || 0) + IMAGE_HEADING_OFFSET;
        } else {
          const dist = Cesium.Cartesian3.distance(prevData.position, position);
          if (dist < 1) {
            // 低速/悬停：保持上一帧航向
            heading = prevData.heading;
          } else {
            // 计算 bearing（大地线方位角，顺时针从正北算起）
            const fromCarto = Cesium.Cartographic.fromCartesian(prevData.position);
            const toCarto = Cesium.Cartographic.fromCartesian(position);
            const dLon = toCarto.longitude - fromCarto.longitude;
            const y = Math.sin(dLon) * Math.cos(toCarto.latitude);
            const x = Math.cos(fromCarto.latitude) * Math.sin(toCarto.latitude) -
                      Math.sin(fromCarto.latitude) * Math.cos(toCarto.latitude) * Math.cos(dLon);
            const bearing = Math.atan2(y, x); // 顺时针从正北算起的弧度
            // Cesium rotation 逆时针为正，bearing 顺时针为正
            let newHeading = -bearing + IMAGE_HEADING_OFFSET;
            // 归一化到 [-π, π]
            while (newHeading > Math.PI) newHeading -= 2 * Math.PI;
            while (newHeading < -Math.PI) newHeading += 2 * Math.PI;
            // 低通滤波平滑（0.3 平滑因子）
            let diff = newHeading - prevData.heading;
            while (diff > Math.PI) diff -= 2 * Math.PI;
            while (diff < -Math.PI) diff += 2 * Math.PI;
            heading = prevData.heading + diff * 0.3;
          }
        }
        prevPositionStore.set(card.icao, {
          position: Cesium.Cartesian3.clone(position),
          heading: heading,
        });
        const text = `ICAO:${icao}`;
        const now = Cesium.JulianDate.now();

        // 查找是否已存在该实体
        let entity = adsbDataSource.entities.getById(id);

        // 获取或创建采样存储
        let store = adsbSampleStore.get(icao);

        if (entity && store) {
          // --- 双采样点+时间偏移：确保运动始终处于插值状态 ---
          const prevPosition = prevData?.position; // 上一帧位置（锚点）

          // 移除所有旧采样点
          while (store.times.length > 0) {
            store.property.removeSample(store.times.shift());
          }

          if (prevPosition) {
            // 锚点：上一帧位置固定到"当前时间"
            store.property.addSample(now, prevPosition);
            store.times.push(Cesium.JulianDate.clone(now));
          }

          // 目标点：当前位置时间戳推迟 POSITION_TIME_OFFSET 秒
          const targetTime = Cesium.JulianDate.addSeconds(now, POSITION_TIME_OFFSET, new Cesium.JulianDate());
          store.property.addSample(targetTime, position);
          store.times.push(targetTime);

          entity.billboard.rotation = heading;
          entity.billboard.alignedAxis = Cesium.Cartesian3.ZERO;
          entity.billboard.verticalOrigin = Cesium.VerticalOrigin.CENTER;
          entity.billboard.horizontalOrigin = Cesium.HorizontalOrigin.CENTER;
          entity.label.text = text;
          // 同步更新样式
          entity.label.font = "14px Microsoft YaHei";
          entity.label.showBackground = true;
          entity.label.backgroundColor = Cesium.Color.fromCssColorString(
            "rgba(30, 39, 50, 0.8)"
          );
          entity.label.backgroundPadding = new Cesium.Cartesian2(10, 5);

          // 更新弹窗数据 (如果有的话)
          if (entity.popInstance && entity.popInstance.subData) {
            entity.popInstance.subData = {
              icao: icao,
              speed: speed,
              altitude: altitude,
              latitude:
                this.formatDegree(latitude)[0] +
                "°" +
                this.formatDegree(latitude)[1] +
                "′" +
                this.formatDegree(latitude)[2] +
                "″",
              longitude:
                this.formatDegree(longitude)[0] +
                "°" +
                this.formatDegree(longitude)[1] +
                "′" +
                this.formatDegree(longitude)[2] +
                "″",
              direction: direction + "°",
              rateClimb: rateClimb,
              updateTime: updateTime,
              callNumber: callNumber,
              transponder: transponder,
            };
          }
        } else if (entity && !store) {
          // --- 旧实体（没有采样队列）：原地升级为 SampledPositionProperty，双采样点+时间偏移 ---
          const sampledPos = new Cesium.SampledPositionProperty();
          sampledPos.setInterpolationOptions({
            interpolationDegree: 1,
            interpolationAlgorithm: Cesium.LinearApproximation,
          });
          sampledPos.forwardExtrapolationType = Cesium.ExtrapolationType.HOLD;
          sampledPos.backwardExtrapolationType = Cesium.ExtrapolationType.HOLD;
          entity.position = sampledPos;

          const times = [];
          const prevPosition = prevData?.position;
          if (prevPosition) {
            sampledPos.addSample(now, prevPosition);
            times.push(Cesium.JulianDate.clone(now));
          }
          const targetTime = Cesium.JulianDate.addSeconds(now, POSITION_TIME_OFFSET, new Cesium.JulianDate());
          sampledPos.addSample(targetTime, position);
          times.push(targetTime);
          store = { property: sampledPos, times };
          adsbSampleStore.set(icao, store);

          entity.billboard.rotation = heading;
          entity.billboard.alignedAxis = Cesium.Cartesian3.ZERO;
          entity.billboard.verticalOrigin = Cesium.VerticalOrigin.CENTER;
          entity.billboard.horizontalOrigin = Cesium.HorizontalOrigin.CENTER;
          entity.label.text = text;
          // 同步更新样式
          entity.label.font = "14px Microsoft YaHei";
          entity.label.showBackground = true;
          entity.label.backgroundColor = Cesium.Color.fromCssColorString(
            "rgba(30, 39, 50, 0.8)"
          );
          entity.label.backgroundPadding = new Cesium.Cartesian2(10, 5);

          // 更新弹窗数据
          if (entity.popInstance && entity.popInstance.subData) {
            entity.popInstance.subData = {
              icao: icao,
              speed: speed,
              altitude: altitude,
              latitude:
                this.formatDegree(latitude)[0] +
                "°" +
                this.formatDegree(latitude)[1] +
                "′" +
                this.formatDegree(latitude)[2] +
                "″",
              longitude:
                this.formatDegree(longitude)[0] +
                "°" +
                this.formatDegree(longitude)[1] +
                "′" +
                this.formatDegree(longitude)[2] +
                "″",
              direction: direction + "°",
              rateClimb: rateClimb,
              updateTime: updateTime,
              callNumber: callNumber,
              transponder: transponder,
            };
          }
        } else {
          // --- 如果不存在，创建新实体（使用 SampledPositionProperty 实现平滑移动） ---
          const sampledPos = new Cesium.SampledPositionProperty();
          sampledPos.setInterpolationOptions({
            interpolationDegree: 1, // 线性插值
            interpolationAlgorithm: Cesium.LinearApproximation,
          });
          sampledPos.addSample(now, position);
          sampledPos.forwardExtrapolationType = Cesium.ExtrapolationType.HOLD;
          sampledPos.backwardExtrapolationType = Cesium.ExtrapolationType.HOLD;

          // 存储采样队列
          adsbSampleStore.set(icao, {
            property: sampledPos,
            times: [Cesium.JulianDate.clone(now)],
          });

          entity = adsbDataSource.entities.add({
            id: id,
            position: sampledPos,
            billboard: {
              image: image,
              alignedAxis: Cesium.Cartesian3.ZERO, // 默认屏幕对齐，billboard始终面向相机
              verticalOrigin: Cesium.VerticalOrigin.CENTER,
              horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
              scale: 0.8,
              rotation: heading,
              color: Cesium.Color.YELLOW.withAlpha(0.9),
            },
            label: {
              text: text,
              font: "14px Microsoft YaHei",
              style: Cesium.LabelStyle.FILL,
              fillColor: Cesium.Color.WHITE,
              showBackground: true,
              backgroundColor: Cesium.Color.fromCssColorString("rgba(30, 39, 50, 0.8)"), // 深色半透明背景
              backgroundPadding: new Cesium.Cartesian2(10, 5),
              verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
              pixelOffset: new Cesium.Cartesian2(0, -30),
              distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 900000),
            },
          });

          // 创建弹窗
          var pop = new PopLayer({
            height: 310,
            height_off: 20,
            entity: entity,
            dialog: this.$dialog,
            componet: ADSMsg,
            subData: {
              icao: icao,
              speed: speed,
              altitude: altitude,
              latitude:
                this.formatDegree(latitude)[0] +
                "°" +
                this.formatDegree(latitude)[1] +
                "′" +
                this.formatDegree(latitude)[2] +
                "″",
              longitude:
                this.formatDegree(longitude)[0] +
                "°" +
                this.formatDegree(longitude)[1] +
                "′" +
                this.formatDegree(longitude)[2] +
                "″",
              direction: direction + "°",
              rateClimb: rateClimb,
              updateTime: updateTime,
              callNumber: callNumber,
              transponder: transponder,
            },
            title: "设备信息",
            onOpen: (clickedEntity, subData) => {
              console.log("飞机被点击，开始获取轨迹:", subData.icao);
              this._fetchAndDrawTrajectory(clickedEntity, subData.icao);
            },
            onClose: (clickedEntity) => {
              console.log("弹窗关闭，移除轨迹线");
              this._removeTrajectoryLine(clickedEntity);
            },
          });

          // 将弹窗实例存入实体，方便后续更新
          entity.popInstance = pop;
          adsbPopCollection.push(pop);
        }
      });

      // (可选) 清理已经不在返回数据中的飞机
      const currentIds = validPlanes.map((p) => `${p.icao}_小飞机`);
      const entitiesToRemove = [];
      adsbDataSource.entities.values.forEach((ent) => {
        if (!currentIds.includes(ent.id)) {
          entitiesToRemove.push(ent);
        }
      });

      entitiesToRemove.forEach((ent) => {
        // 清理采样队列
        const icaoKey = ent.id.replace("_小飞机", "");
        adsbSampleStore.delete(icaoKey);
        prevPositionStore.delete(icaoKey);

        // 清理轨迹线
        this._removeTrajectoryLine(ent);

        // 销毁对应的弹窗
        if (ent.popInstance) {
          ent.popInstance.destroy?.();
          const index = adsbPopCollection.indexOf(ent.popInstance);
          if (index > -1) adsbPopCollection.splice(index, 1);
        }
        adsbDataSource.entities.remove(ent);
      });
    },

    formatDegree(value) {
      value = Math.abs(value);
      var v1 = Math.floor(value); //度
      var v2 = Math.floor((value - v1) * 60); //分
      var v3 = Math.round(((value - v1) * 3600) % 60); //秒
      return [v1, v2, v3];
    },

    /**
     * 清空ADS-B飞机聚合实体（包含聚合数据源、弹窗、内存清理）
     * @param {Boolean} keepDataSource - 是否保留数据源（仅清空实体，默认false：完全销毁数据源）
     */
    clearADSPoints(keepDataSource = false) {
      console.log("开始清空ADS-B飞机实体...");

      // 清空位置采样队列
      adsbSampleStore.clear();
      // 清空航向存储
      prevPositionStore.clear();

      // 1. 销毁所有飞机弹窗（避免内存泄漏）
      if (adsbPopCollection && adsbPopCollection.length > 0) {
        adsbPopCollection.forEach((pop) => {
          try {
            // 调用弹窗的销毁方法（适配你的PopLayer逻辑）
            if (pop.destroy) pop.destroy();
            // 额外清理弹窗关联的DOM/事件（如果有）
            if (pop.dialog && pop.dialog.close) pop.dialog.close();
          } catch (e) {
            console.warn("销毁弹窗失败：", e);
          }
        });
        // 清空弹窗数组
        adsbPopCollection = [];
      }

      // 2. 清空/销毁聚合数据源
      if (adsbDataSource) {
        // 先移除所有实体
        adsbDataSource.entities.removeAll();

        // 如果不保留数据源，完全销毁并从viewer中移除
        if (!keepDataSource) {
          if (window.adsbClusterCallback) {
            adsbDataSource.clustering.clusterEvent.removeEventListener(
              window.adsbClusterCallback
            );
            window.adsbClusterCallback = null; // 清空回调引用
          }
          // 方式2：即使没保存回调，直接禁用聚合+移除数据源也能彻底清理
          adsbDataSource.clustering.enabled = false;
          // 从viewer中移除数据源
          viewer.dataSources.remove(adsbDataSource);
          // 销毁数据源引用（释放内存）
          adsbDataSource = null;
        }
      }
      console.log("ADS-B飞机实体清空完成");
    },

    initADSPoint_E(res, image) {
      image = "data/img/marker/feiji4.png";
      let result = res.states;
      for (let i = 0; i < result.length; i++) {
        let card = result[i];
        if (card[5] > 1 && card[6] > 1) {
          var p = Cesium.Cartesian3.fromDegrees(card[5], card[6], card[7]);

          var id = card[0] + "_小飞机";
          var text = `(${card[0]})`;

          let entity = this.createBillboardEntityFly(p, id, text, image);
          DBentityCollection.add(entity);

          if (!entity.hasPop) {
            var pop = new PopLayer({
              entity: entity,
              dialog: this.$dialog,
              componet: ADSMsg,
              subData: {},
              title: "设备信息",
            });

            popCollection.push(pop);

            entity.hasPop = true;
          }
        }
      }
    },
    initPoint(image) {
      const loading = this.$loading({
        lock: true,
        text: "数据同步中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let baseH = modelBaseH; //基础高度8千米
      getlistDeviceLocation()
        .then((res) => {
          loading.close();
          //let result = res.result.slice(0, maxPointNum);
          let result = res.result;
          console.log("总个数", result.length);
          let count_use = 0;
          for (let i = 0; i < result.length; i++) {
            let card = result[i];
            if (card.longitude > 1 && card.latitude > 1) {
              count_use++;
              var p = Cesium.Cartesian3.fromDegrees(
                card.longitude,
                card.latitude,
                card.altitude + baseH
              );

              var id = card.cardNumber + "_小飞机";
              var text = `卡号(${card.cardNumber})`;

              let entity = this.createBillboardEntityFly(p, id, text, image);
              DBentityCollection.add(entity);

              if (!entity.hasPop) {
                var pop = new PopLayer({
                  entity: entity,
                  dialog: this.$dialog,
                  componet: DeviceMsg,
                  subData: card.cardNumber,
                  title: "设备信息",
                });

                popCollection.push(pop);

                entity.hasPop = true;
              }
            }
          }

          console.log("真实数", count_use);
        })
        .catch((e) => {
          loading.close();
          console.error(e);
        });
    },

    createBillboardEntityFly(center, id, text, image) {
      const entity = new Cesium.Entity({
        id: id,
        position: center,
        label: {
          text: text || "设备",
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          font: "16px sans-serif",
          pixelOffset: new Cesium.Cartesian2(0, -20), //6,229,72
          fillColor: new Cesium.Color(6 / 255, 229 / 255, 72 / 255),
          distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 12000), // 设置最小和最大距离
          //pixelOffsetScaleByDistance: new Cesium.NearFarScalar(1.0e3, -20, 1.5e6, -80),
        },

        billboard: {
          image: image || "data/img/marker/feiji.png",
          //scale: 0.6,
          scaleByDistance: new Cesium.NearFarScalar(8000, 1.4, 40000, 0.6),
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.CENTER,
          heightReference: Cesium.HeightReference.NONE,
        },
        model: {
          show: false,
          uri: "data/mx/feiji.glb", //模型的地址
          scale: modelScale, //模型缩放比例
          minimumPixelSize: modelMinimumPixelSize, //
          maximumScale: 20000, // 模型的最大比例尺大小。 minimumPixelSize的上限
          incrementallyLoadTextures: true, // 加载模型后纹理是否可以继续流入
          runAnimations: true, // 是否应启动模型中指定的glTF动画
          clampAnimations: true, // 指定glTF动画是否应在没有关键帧的持续时间内保持最后一个姿势
          shadows: Cesium.ShadowMode.ENABLED,
          heightReference: Cesium.HeightReference.NONE, //设置模型贴地,
        },
      });
      return entity;
    },
    initFlyServer(arrLine) {
      const loading = this.$loading({
        lock: true,
        text: "数据同步中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      let items = arrLine || {};
      this.doFlyServer(items, true);
      loading.close();
    },
    densifyPositions(positions, interval = 10) {
      const result = [];
      for (let i = 0; i < positions.length - 1; i++) {
        const start = positions[i];
        const end = positions[i + 1];
        result.push(start);

        const distance = Cesium.Cartesian3.distance(start, end);
        if (distance > interval) {
          const segments = Math.floor(distance / interval);
          for (let j = 1; j < segments; j++) {
            const t = (j * interval) / distance;
            const interpolated = new Cesium.Cartesian3();
            Cesium.Cartesian3.lerp(start, end, t, interpolated);
            result.push(interpolated);
          }
        }
      }
      result.push(positions[positions.length - 1]);
      return result;
    },
    getDataServer(arr, key) {
      let url = getModelUrl(key);
      arr.reverse(); //倒序

      var positions = [];
      var lineCoods = [];
      let itemZero = arr[0];
      let id = "轨迹信息" + itemZero.sendCardNumber;
      var text = `卡号(${itemZero.sendCardNumber})`;
      for (let i = 0; i < arr.length; i++) {
        var item = arr[i];
        var pos = Cesium.Cartesian3.fromDegrees(
          item.longitude,
          item.latitude,
          item.altitude
        );
        positions.push(pos);
        lineCoods.push([item.longitude, item.latitude, item.altitude]);
      }
      var entity = DBentityCollection.getById(id); //下标

      if (lineCoods.length > 2) {
        positions = this.createCurvedLine(positions, {
          samplesPerSegment: 50,
        });
      }

      if (!entity) {
        entity = this.createFlydEntity(positions[0], id, text, positions, url);
        DBentityCollection.add(entity);
      }
      entity.fltPath = positions;
      return entity;
    },
    getADSDataServer(arr, text) {
      var positions = [];
      var lineCoods = [];
      let id = "ADS" + text;
      let url = "";
      for (let i = 0; i < arr.length; i++) {
        var item = arr[i];
        var pos = Cesium.Cartesian3.fromDegrees(
          item.longitude,
          item.latitude,
          item.altitude
        );
        positions.push(pos);
        lineCoods.push([item.longitude, item.latitude, item.altitude]);
      }
      var entity = DBentityCollection.getById(id); //下标

      if (lineCoods.length > 2) {
        positions = this.createCurvedLine(positions, {
          samplesPerSegment: 50,
        });
      }

      if (!entity) {
        entity = this.createADSFlydEntity(positions[0], id, text, positions, url);
        DBentityCollection.add(entity);
      }
      entity.fltPath = positions;
      return entity;
    },

    /**
     * 点击飞机图标时：获取历史轨迹并绘制轨迹线
     * @param {Cesium.Entity} entity - 被点击的飞机实体
     * @param {string} icao - ICAO码
     */
    async _fetchAndDrawTrajectory(entity, icao) {
      // 防止重复请求
      if (entity._trajectoryLoading || entity._trajectoryLine) {
        return;
      }
      entity._trajectoryLoading = true;

      try {
        const res = await getAdsbLocationGJ({ icao });
        const trajectoryData = res.result || [];
        if (!trajectoryData || trajectoryData.length < 2) {
          console.warn(`飞机 ${icao} 轨迹数据不足（< 2个点），不绘制轨迹线`);
          return;
        }

        // 提取坐标点并反转（确保箭头方向与飞行方向一致：从旧到新）
        const positions = trajectoryData
          .map((item) =>
            Cesium.Cartesian3.fromDegrees(item.longitude, item.latitude, item.altitude || 0)
          )
          .reverse();

        // 多于2个点时做平滑插值
        let finalPositions = positions;
        if (positions.length > 2) {
          finalPositions = this.createCurvedLine(positions, {
            samplesPerSegment: 50,
          });
        }

        // 创建轨迹线实体
        const trajectoryEntity = viewer.entities.add({
          polyline: {
            positions: finalPositions,
            width: 4,
            material: new Cesium.PolylineArrowMaterialProperty(
              Cesium.Color.DEEPSKYBLUE.withAlpha(0.8)
            ),
            clampToGround: false,
          },
        });

        // 挂到飞机实体上，方便后续清理
        entity._trajectoryLine = trajectoryEntity;
        console.log(`飞机 ${icao} 历史轨迹已绘制，共 ${trajectoryData.length} 个点`);
      } catch (err) {
        console.error(`获取飞机 ${icao} 轨迹失败:`, err);
      } finally {
        entity._trajectoryLoading = false;
      }
    },
    /**
     * 弹窗关闭时：移除轨迹线
     * @param {Cesium.Entity} entity - 飞机实体
     */
    _removeTrajectoryLine(entity) {
      if (entity._trajectoryLine) {
        viewer.entities.remove(entity._trajectoryLine);
        entity._trajectoryLine = null;
      }
    },

    doADSBFlyServer(traceData, info) {
      console.log(info);
      let ent = this.getADSDataServer(traceData, "ICAO:" + info.icao);

      viewer.flyTo(ent, {
        duration: 3,
        offset: new Cesium.HeadingPitchRange(0, -Math.PI / 2, 80000), //（heading,pich,range）
      });

      let positions = ent.fltPath;
      var animation = new PathAnimation({
        entity: ent,
        positions: positions,
        speed: 200,
        multiple: 1,
        originPath: traceData,
      });
      animation.start();

      if (!ent.hasPop) {
        var pop = new PopLayer({
          entity: ent,
          dialog: this.$dialog,
          componet: ADSMsg,
          subData: info,
          title: "设备信息",
          animation: animation,
        });

        popCollection.push(pop);

        ent.hasPop = true;

        pop.open();
      }
    },
    doFlyServer(linesMap, flyTo) {
      let count = 0;
      for (const key in linesMap) {
        if (linesMap.hasOwnProperty(key)) {
          count++;
          // 确保是对象自身的属性
          console.log(key, linesMap[key]);
          let lineArr = this.removeDuplicateData(linesMap[key]);

          let ent = this.getDataServer(lineArr, key);
          let positions = ent.fltPath;
          ent.show = true; //
          let item = lineArr[0];

          //飞行动画
          var animation = new PathAnimation({
            entity: ent,
            positions: positions,
            speed: 200,
            multiple: 1,
            originPath: lineArr,
          });
          animation.start();

          //弹窗信息
          var pop = new PopLayer({
            entity: ent,
            dialog: this.$dialog,
            componet: DeviceMsg,
            subData: item.sendCardNumber,
            title: "设备信息",
            animation: animation,
          });

          popCollection.push(pop);
          if (count <= 3) {
            pop.open();
          }
          if (flyTo && count === 1) {
            viewer.flyTo(ent, {
              duration: 3,
              offset: new Cesium.HeadingPitchRange(0, -Math.PI / 2, 80000), //（heading,pich,range）
            });
          }

          if (lineArr.length < 2) {
            continue;
          }
        }
      }
    },
    removeDuplicateData(positions) {
      if (positions.length < 2) {
        return positions;
      }
      let res = [];
      let j = 0;
      res.push(positions[0]);
      for (let i = 1; i < positions.length; i++) {
        if (
          res[j].longitude == positions[i].longitude &&
          res[j].latitude == positions[i].latitude &&
          res[j].altitude == positions[i].altitude
        ) {
          continue;
        }
        if (positions[i].speed == 0) {
          continue;
        }
        j++;
        res.push(positions[i]);
      }
      return res;
    },
    //计算总长(米)
    getLength(positions) {
      if (!Cesium.defined(positions) || positions.length < 2) return 0;

      var distance = 0;
      for (var i = 1, len = positions.length; i < len; i++) {
        distance += Cesium.Cartesian3.distance(positions[i - 1], positions[i]);
      }
      return distance;
    },
    coordinatesToPos(coordinates) {
      var positions = [];
      for (let i = 0; i < coordinates.length; i++) {
        var coord = coordinates[i];
        var pos = Cesium.Cartesian3.fromDegrees(coord[0], coord[1]);
        positions.push(pos);
      }

      return positions;
    },
    removeDuplicate(positions) {
      if (positions.length < 2) {
        return positions;
      }
      let res = [];
      let j = 0;
      res.push(positions[0]);
      for (let i = 1; i < positions.length; i++) {
        if (
          res[j].x == positions[i].x &&
          res[j].y == positions[i].y &&
          res[j].z == positions[i].z
        ) {
          continue;
        }
        j++;
        res.push(positions[i]);
      }
      return res;
    },

    createADSFlydEntity(center, id, text, positions, url) {
      // let lineCallback = [];
      // let lineCallbackProperty = new Cesium.CallbackProperty(function (time) {
      //   return lineCallback;
      // }, false); //圆锥高度

      const entity = new Cesium.Entity({
        id: id,
        position: center,
        label: {
          text: text || "设备",
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          font: "16px sans-serif",
          pixelOffset: new Cesium.Cartesian2(0, -30), //6,229,72
          fillColor: new Cesium.Color(6 / 255, 229 / 255, 72 / 255),
          //pixelOffsetScaleByDistance: new Cesium.NearFarScalar(1.0e3, -20, 1.5e6, -80),
        },
        model: {
          show: true,
          uri: url || "data/mx/feiji.glb", //模型的地址
          scale: 1, //模型缩放比例
          minimumPixelSize: modelMinimumPixelSize, //
          maximumScale: 20000, // 模型的最大比例尺大小。 minimumPixelSize的上限
          incrementallyLoadTextures: true, // 加载模型后纹理是否可以继续流入
          runAnimations: true, // 是否应启动模型中指定的glTF动画
          clampAnimations: true, // 指定glTF动画是否应在没有关键帧的持续时间内保持最后一个姿势
          //shadows: Cesium.ShadowMode.ENABLED,
          shadows: Cesium.ShadowMode.DISABLED,
          heightReference: Cesium.HeightReference.NONE, //设置模型贴地,
        },
        polyline: {
          positions: positions,
          width: 10,
          //granularity: 10, // 减少granularity可以减少顶点数量
          material: new Cesium.PolylineArrowMaterialProperty(
            Cesium.Color.fromRandom({
              alpha: 1.0,
            })
          ),
          // material: new Cesium.PolylineTrailLinkMaterialProperty(
          //     {
          //         color: new Cesium.Color(1.0, 1.0, 0.0, 1),
          //         duration: 3000,
          //         image: "data/img/effects/line-pulse.png"
          //     }
          // ),
          //clampToGround: true,
        },
      });
      return entity;
    },
    createFlydEntity(center, id, text, positions, url) {
      // let lineCallback = [];
      // let lineCallbackProperty = new Cesium.CallbackProperty(function (time) {
      //   return lineCallback;
      // }, false); //圆锥高度

      const entity = new Cesium.Entity({
        id: id,
        position: center,
        label: {
          text: text || "设备",
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          font: "16px sans-serif",
          pixelOffset: new Cesium.Cartesian2(0, -20), //6,229,72
          fillColor: new Cesium.Color(6 / 255, 229 / 255, 72 / 255),
          //pixelOffsetScaleByDistance: new Cesium.NearFarScalar(1.0e3, -20, 1.5e6, -80),
        },
        model: {
          show: true,
          uri: url || "data/mx/feiji.glb", //模型的地址
          scale: modelScale, //模型缩放比例
          minimumPixelSize: modelMinimumPixelSize, //
          maximumScale: 20000, // 模型的最大比例尺大小。 minimumPixelSize的上限
          incrementallyLoadTextures: true, // 加载模型后纹理是否可以继续流入
          runAnimations: true, // 是否应启动模型中指定的glTF动画
          clampAnimations: true, // 指定glTF动画是否应在没有关键帧的持续时间内保持最后一个姿势
          shadows: Cesium.ShadowMode.ENABLED,
          heightReference: Cesium.HeightReference.NONE, //设置模型贴地,
        },
        polyline: {
          positions: positions,
          width: 10,
          //granularity: 10, // 减少granularity可以减少顶点数量
          material: new Cesium.PolylineArrowMaterialProperty(
            Cesium.Color.fromRandom({
              alpha: 1.0,
            })
          ),
          // material: new Cesium.PolylineTrailLinkMaterialProperty(
          //     {
          //         color: new Cesium.Color(1.0, 1.0, 0.0, 1),
          //         duration: 3000,
          //         image: "data/img/effects/line-pulse.png"
          //     }
          // ),
          //clampToGround: true,
        },
      });
      return entity;
    },

    /**
     * 使用Cesium插值属性实现折线平滑
     * @param {Array} points - Cesium.Cartesian3点数组，表示原始折线
     * @param {Object} [options] - 插值选项
     * @param {Number} [options.degree=3] - 插值多项式次数
     * @param {Cesium.InterpolationAlgorithm} [options.algorithm=Cesium.HermitePolynomialApproximation] - 插值算法
     * @param {Number} [options.samplesPerSegment=10] - 每段生成的样本点数
     * @returns {Array} 平滑后的曲线点数组
     */
    /**
     * Catmull-Rom 样条插值：生成平滑无尖角的轨迹线
     * 流程：去重 → 滑动平均降噪 → Catmull-Rom 逐段插值
     */
    createCurvedLine(points, options = {}) {
      const { samplesPerSegment = 30 } = options;

      if (!points || points.length < 2) return points;

      // ===== 步骤1：去除距离过近的重复/冗余点 =====
      const deduped = [];
      for (let i = 0; i < points.length; i++) {
        if (i === 0 || Cesium.Cartesian3.distance(points[i], deduped[deduped.length - 1]) > 0.5) {
          deduped.push(points[i]);
        }
      }
      if (deduped.length < 2) return points;

      // ===== 步骤2：3 点滑动平均降噪 =====
      const smoothed = [];
      smoothed.push(deduped[0]);
      for (let i = 1; i < deduped.length - 1; i++) {
        const w0 = deduped[i - 1], w1 = deduped[i], w2 = deduped[i + 1];
        smoothed.push(new Cesium.Cartesian3(
          (w0.x + w1.x + w2.x) / 3,
          (w0.y + w1.y + w2.y) / 3,
          (w0.z + w1.z + w2.z) / 3
        ));
      }
      smoothed.push(deduped[deduped.length - 1]);

      // ===== 步骤3：Catmull-Rom 逐段插值 =====
      return this._catmullRomInterpolate(smoothed, samplesPerSegment);
    },

    /**
     * Catmull-Rom 逐段插值（均匀参数化）
     * 过所有控制点，C1 连续，无振荡
     */
    _catmullRomInterpolate(pts, samplesPerSegment) {
      const result = [pts[0].clone()];

      for (let i = 0; i < pts.length - 1; i++) {
        const p0 = pts[Math.max(0, i - 1)];
        const p1 = pts[i];
        const p2 = pts[i + 1];
        const p3 = pts[Math.min(pts.length - 1, i + 2)];

        for (let j = 1; j <= samplesPerSegment; j++) {
          const t = j / samplesPerSegment;
          result.push(CatmullRom.interpolate(p0, p1, p2, p3, t));
        }
      }

      result.push(pts[pts.length - 1].clone());
      return result;
    },

    /**
     * 使用turf.js生成平滑曲线
     * @param {Array} points - 点数组 [[lng, lat, height], ...]
     * @param {number} exaggeration - 高度夸张系数
     * @returns {Array} Cesium.Cartesian3数组
     */
    createTurfCurve(points, exaggeration = 1) {
      // 创建仅包含经纬度的线要素
      const geoPoints = points.map((p) => [p[0], p[1]]);
      const lineString = turf.lineString(geoPoints);

      // 获取曲线参数
      const resolution = 20000;
      const sharpness = 1;

      // 生成二维曲线
      const curved = turf.bezierSpline(lineString, {
        resolution: resolution,
        sharpness: sharpness,
      });

      // 为每个点分配高度（基于原始点高度进行插值）
      const curvedPoints = curved.geometry.coordinates;
      const heights = this.getSmoothedHeights(points, curvedPoints.length, exaggeration);

      // 转换为Cesium Cartesian3点
      return curvedPoints.map((coord, i) =>
        Cesium.Cartesian3.fromDegrees(coord[0], coord[1], heights[i])
      );
    },

    /**
     * 为turf曲线点计算平滑高度
     * @param {Array} points - 原始点数据 [[lng, lat, height], ...]
     * @param {number} count - 需要的高度值数量
     * @param {number} exaggeration - 高度夸张系数
     * @returns {Array} 高度值数组
     */
    getSmoothedHeights(points, count, exaggeration) {
      const heights = points.map((p) => p[2]);

      // 简单的线性插值
      const step = points.length > 1 ? (points.length - 1) / (count - 1) : 0;
      const smoothed = [];

      for (let i = 0; i < count; i++) {
        const idx = i * step;
        const lowIdx = Math.floor(idx);
        const highIdx = Math.min(Math.ceil(idx), points.length - 1);

        if (lowIdx === highIdx) {
          smoothed.push(heights[lowIdx] * exaggeration);
        } else {
          const fraction = idx - lowIdx;
          const interpolated =
            heights[lowIdx] * (1 - fraction) + heights[highIdx] * fraction;
          smoothed.push(interpolated * exaggeration);
        }
      }

      return smoothed;
    },

    addData() {
      var tiles3dLayer_DY = new TilesetLayer({
        name: "点云数据",
        url: "http://data.mars3d.cn/3dtiles/pnts-ganta/tileset.json",
        position: {
          z: 31,
        },
        style: {
          color: {
            conditions: [
              [
                "(${Classification} >= 4) && (${Classification} < 5) ",
                "color('#DC143C')",
              ],
              [
                "(${Classification} >= 7) && (${Classification} < 8)  ",
                "color('#7B68EE')",
              ],
              [
                "(${Classification} >= 16) && (${Classification} < 17)  ",
                "color('#00CED1')",
              ],
              [
                "(${Classification} >= 17) && (${Classification} < 18)  ",
                "color('#3CB371')",
              ],
              [
                "(${Classification} >= 18) && (${Classification} < 19)  ",
                "color('#FFFF00')",
              ],
              [
                "(${Classification} >= 19) && (${Classification} < 20)  ",
                "color('#FFA500')",
              ],
              [
                "(${Classification} >= 20) && (${Classification} < 21)  ",
                "color('#FF6347')",
              ],
            ],
          },
        },
        maximumScreenSpaceError: 16,
        maximumMemoryUsage: 1024,
        flyTo: true,
      });

      DBmap.addLayer(tiles3dLayer_DY, "点云数据", "tilesetLayer");

      var tiles3dLayer_QX_XC = new TilesetLayer({
        name: "倾斜摄影(县城)",
        url: "http://data.mars3d.cn/3dtiles/qx-shequ/tileset.json",
        position: {
          z: 11.5,
        },
        maximumMemoryUsage: 1024,
        dynamicScreenSpaceError: true,
        cullWithChildrenBounds: false,
        maximumScreenSpaceError: 16,
        maximumMemoryUsage: 1024,
        flyTo: true,
        transform: false,
      });

      DBmap.addLayer(tiles3dLayer_QX_XC, "倾斜摄影(县城)", "tilesetLayer");

      var tiles3dLayer_QX_WM = new TilesetLayer({
        name: "倾斜摄影(文庙)",
        position: {
          z: 80.6,
        },
        url: "http://data.mars3d.cn/3dtiles/qx-simiao/tileset.json",
        maximumMemoryUsage: 1024,
        dynamicScreenSpaceError: true,
        cullWithChildrenBounds: false,
        maximumScreenSpaceError: 1,
        flyTo: true,
        transform: false,
      });

      DBmap.addLayer(tiles3dLayer_QX_WM, "倾斜摄影(文庙)", "tilesetLayer");

      var tiles3dLayer_RG = new TilesetLayer({
        name: "人工模型",
        url: "http://data.mars3d.cn/3dtiles/max-shihua/tileset.json",
        position: { x: 117.077158, y: 31.659116, z: 24.6 },
        maximumScreenSpaceError: 1,
        maximumMemoryUsage: 1024,
        maximumScreenSpaceError: 1,
        flyTo: true,
        transform: true,
      });

      DBmap.addLayer(tiles3dLayer_RG, "人工模型", "tilesetLayer");

      var tiles3dLayer_BIM = new TilesetLayer({
        name: "BIM模型(桥梁)",
        url: "http://data.mars3d.cn/3dtiles/bim-qiaoliang/tileset.json",
        position: { x: 117.096906, y: 31.851564, z: 45 },
        // "rotation": { "z": -400 },
        maximumScreenSpaceError: 1,
        maximumMemoryUsage: 1024,
        maximumScreenSpaceError: 1,
        flyTo: true,
        transform: true,
      });

      DBmap.addLayer(tiles3dLayer_BIM, "BIM模型(桥梁)", "tilesetLayer");
    },
    zhihuiji() {
      // const labelEntity = new Cesium.Entity({
      //   position: Cesium.Cartesian3.fromDegrees(113.086938, 22.934261),
      //   name: "有背景色文字",
      //   label: {
      //     text: "欢迎来到Cesium",
      //     scale: 1,
      //     showBackground: true, //显示背景
      //     backgroundColor: Cesium.Color.DARKGREY, //背景色
      //     backgroundPadding: new Cesium.Cartesian2(50, 5), //padding值
      //     horizontalOrigin: Cesium.HorizontalOrigin.LEFT, //对齐方式
      //     verticalOrigin: Cesium.VerticalOrigin.CENTER,
      //     fillColor: Cesium.Color.WHITE,
      //     pixelOffset: new Cesium.Cartesian2(0, -20),
      //   },
      // });
      // viewer.entities.add(labelEntity);

      //"result":[{"id":351,"cardNumber":999999,"locationType":0,"longitude":112.880305,"latitude":28.21141,"direction":0.0,"altitude":0.0,"speed":0.0,"createTime":"2022-11-03 13:46:25","updateTime":"2022-12-23 17:20:26"}],"extra":null}
      getZhjDeviceLocation()
        .then((res) => {
          var result = res.result;
          if (!result || result.length < 1) {
            return;
          }
          var data = result[0];
          var heightPos = Cesium.Cartesian3.fromDegrees(
            data.longitude,
            data.latitude,
            data.altitude
          );
          var entity = this.createBillboardEntity(heightPos, "bjwz");
          DBentityCollection.add(entity);
          var zhiPos = Cesium.Cartesian3.fromDegrees(
            data.longitude,
            data.latitude,
            5000.0
          );
          viewer.camera.flyTo({
            destination: zhiPos,
            complete: () => {
              Cesium.zhiPos = zhiPos;
              //Cesium.Camera.DEFAULT_VIEW_RECTANGLE = viewer.camera.computeViewRectangle() || Cesium.Camera.DEFAULT_VIEW_RECTANGLE;
              console.log("complete--zhiPos");
            },
          });
        })
        .catch((e) => {
          console.error(e);
        });
    },
    //图标
    createBillboardEntity(center, id) {
      const entity = new Cesium.Entity({
        id: id,
        position: center,
        billboard: {
          image: "data/img/marker/mark3.png",
          scale: 1.0,
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND,
        },
      });
      return entity;
    },

    callbackEdit(entity, evt) {
      var extType = entity.extType;
      var typeList = {
        point_Nor: {
          name: "点",
          content: com_point,
        },
        billboard_Nor: {
          name: "图标",
          content: com_billboard,
        },
        polyline_Nor: {
          name: "线",
          content: com_line,
        },
        bezier_Nor: {
          name: "曲线",
          content: com_line,
        },
        polygon_Nor: {
          name: "面",
          content: com_polygon,
        },
        polygon_Nor3: {
          name: "面体",
          content: com_polygon3,
        },
        circle_Nor: {
          name: "圆",
          content: com_circle,
        },
        rectangle_Nor: {
          name: "圆",
          content: com_rectangle,
        },
        triangle_Nor: {
          name: "三角形",
          content: com_polygon,
        },
        ellipsoid_Nor: {
          name: "球体",
          content: com_ellipsoid,
        },
        cylinder_Nor: {
          name: "圆锥",
          content: com_cylinder,
        },
        wall_Nor: {
          name: "墙体",
          content: com_wall,
        },
        polylineVolume_Nor: {
          name: "管道",
          content: com_polylineVolume,
        },
        svgEdit_Nor: {
          name: "军标",
          content: com_svgEdit,
        },
      };

      this.openLayer(typeList[extType].name, typeList[extType].content, entity);
    },
    openLayer(type, content, entity) {
      // this.$dialog.plotArr = this.$dialog.plotArr || [];
      // this.$dialog.plotArr.forEach(layerId => {
      //   var ins = this.$dialog.getDialog(layerId);
      //   if (ins) {
      //     ins.close();
      //   }
      // });
      // this.$dialog.plotArr=[entity.id];
      var ins = this.$dialog.getDialog(entity.id);
      if (ins) {
        // if (!ins.ismin && !ins.ismax) {
        //   ins.initSnapshot(); //快照
        // }
        ins.reset();
        return;
      }
      //entity.markName = entity.markName || ""
      this.$dialog.open({
        id: entity.id,
        restore: () => {
          var insObj = this.$dialog.getDialog(entity.id);
          insObj.$children[0].changeMaterialType();
        },
        title: `属性编辑`,
        theme: "feature-dialog",
        shade: false,
        area: {
          height: "800px",
          width: "300px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: content,
          subData: () => entity,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.cesium-viewer-bottom {
  display: none !important;
}

.cesium-viewer-toolbar {
  display: block;
  position: absolute;
  top: 320px;
  right: 25px;
}

.map-div {
  position: fixed;
  margin: 0;
  padding: 0;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;

  #map-room {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }

  .icon-full {
    position: fixed;
    z-index: 2;
    position: fixed;
    z-index: 2;
    right: 32px;
    top: 272px;
    font-size: 30px;
    cursor: pointer;
    color: #dcdfe6;
  }
}
</style>
